import { useState } from "react";
import { useVisualEffects } from "../hooks/VisualEffectsContext";

// Nền trang trí dùng picture để chỉ tải một ảnh đúng kích thước màn hình.
export function VillageBackdrop({ quiet = false }: { quiet?: boolean }) {
  const [failed, setFailed] = useState(false);
  const { backdrop } = useVisualEffects();
  const scene = quiet ? backdrop : "night";
  return (
    <div className={`village-backdrop ${quiet ? "village-backdrop-quiet" : ""} village-${scene}`} aria-hidden="true">
      <picture>
        <source media="(max-width: 767px)" srcSet={`/assets/ui/gothic-v2/village-${scene}-mobile.webp`} />
        <img src={`/assets/ui/gothic-v2/village-${scene}-desktop.webp`} width="1536" height="1024" alt="" fetchPriority={quiet ? "auto" : "high"} style={{ visibility: failed ? "hidden" : undefined }} onError={() => setFailed(true)} onLoad={() => setFailed(false)} />
      </picture>
      <div className="village-vignette" />
      {!quiet && <div className="village-fog"><span /><span /></div>}
    </div>
  );
}
